export function stopAppAudio() {
  if (typeof window === 'undefined') return;
  window.speechSynthesis?.cancel();
  window.dispatchEvent(new CustomEvent('inclusivecore:stop-audio'));
}

export function availableVoices() {
  if (typeof window === 'undefined') return [];
  return window.speechSynthesis?.getVoices?.() ?? [];
}

export function speakText(text, prefs) {
  if (!prefs?.audioEnabled || !text || typeof window === 'undefined' || !window.speechSynthesis) return false;
  stopAppAudio();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = 'en-GB'; utterance.rate = prefs.speechRate || 1;
  utterance.voice = availableVoices().find((voice) => voice.voiceURI === prefs.preferredVoice) || null;
  window.speechSynthesis.speak(utterance);
  return true;
}
